export default [

     {
          path: '/acadimec-record',
          name: 'AcadimecRecord',
          component: () => import("@/views/Page/AcadimecRecord/AcadimecRecord.vue"),
           meta: {
               title: 'AcadimecRecord',
          },
     },
     {
          path: '/acadimec-record/view/:identityNumber',
          name: 'AcademicRecordView',
          component: () => import("@/components/StudentPrintReport.vue"),
          props: (route: any) => ({
              screenMode: true,
              identityNumber: route.params.identityNumber,
          }),
          meta: {
              title: 'Academic Record View',
          },
     }
];
